var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lifecycle-container clearfix" }, [
    _c(
      "div",
      {
        ref: "lifecycleModal",
        staticClass: "reveal lifecycle-modal",
        attrs: { id: _vm.modalId, "data-reveal": "" },
      },
      [
        _vm.histories.length
          ? _c("div", { staticClass: "flex-box" }, [
              _c("div", { staticClass: "flex-box-content" }, [
                _c("p", { staticClass: "confirm-header" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _vm._v(" "),
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _vm.showStatusCol
                        ? _c("th", { staticClass: "lifecycle-modal__status" }, [
                            _vm._v(_vm._s(_vm.$t("status.name"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showCommentCol
                        ? _c(
                            "th",
                            { staticClass: "lifecycle-modal__comment" },
                            [_vm._v(_vm._s(_vm.$t("comment")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("th", { staticClass: "lifecycle-modal__username" }, [
                        _vm._v(_vm._s(_vm.$t("username"))),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "lifecycle-modal__date" }, [
                        _vm._v(_vm._s(_vm.$t("date"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.orderedItems, function (history, index) {
                      return _c("tr", { key: index }, [
                        _vm.showStatusCol
                          ? _c("td", [
                              _vm.type === "directory"
                                ? _c("span", [
                                    _vm.rowStatus(history) ===
                                      _vm.DIR_STATUS.CART &&
                                    history.action === _vm.DIR_ACTION.ADD
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm
                                                  .$t("status.new")
                                                  .toUpperCase() +
                                                  " (" +
                                                  history.action +
                                                  ")"
                                              )
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-shopping-cart cart-icon",
                                          }),
                                        ])
                                      : _vm.rowStatus(history) ===
                                          _vm.DIR_STATUS.CART &&
                                        history.action === _vm.DIR_ACTION.REMOVE
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.DIR_STATUS.PUBLISHED +
                                                  " (" +
                                                  history.action +
                                                  ")"
                                              )
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-shopping-cart cart-icon",
                                          }),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (_vm.rowStatus(history) || "") +
                                                " " +
                                                (history.action
                                                  ? "(" + history.action + ")"
                                                  : "")
                                            )
                                          ),
                                        ]),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("uppercase")(
                                          _vm._f("customStatusLabel")(
                                            _vm.rowStatus(history)
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showCommentCol
                          ? _c(
                              "td",
                              { staticClass: "lifecycle-modal__comment" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "lifecycle-modal__comment-content",
                                  },
                                  [
                                    _vm.htmlCommentAttr &&
                                    _vm.getCommentCellHtml(history)
                                      ? _c("div", {
                                          staticClass:
                                            "lifecycle-modal__comment-html",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getCommentCellHtml(history)
                                            ),
                                          },
                                        })
                                      : _vm.allowPreformattedComments
                                      ? _c("pre", [
                                          _vm._v(
                                            _vm._s(
                                              history.detail[_vm.commentAttr]
                                            )
                                          ),
                                        ])
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              history.detail[_vm.commentAttr]
                                            )
                                          ),
                                        ],
                                    _vm._v(" "),
                                    history.docs
                                      ? [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(_vm.$t("attachments")) +
                                                ": "
                                            ),
                                            history.docs &&
                                            history.docs.length === 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " + _vm._s(_vm.$t("na"))
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            history.docs,
                                            function (file, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadfile(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(file.filename)
                                                      ),
                                                    ]
                                                  ),
                                                  _c("br"),
                                                ]
                                              )
                                            }
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "lifecycle-modal__username" }, [
                          _vm._v(_vm._s(_vm.lifecycleWhoDisplay(history))),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "lifecycle-modal__date" }, [
                          _vm._v(
                            _vm._s(_vm.formatDate(_vm.rowCreatedAt(history)))
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.emptyHistoryHint && !_vm.histories.length
          ? _c("div", { staticClass: "font-bold" }, [
              _vm._v(_vm._s(_vm.emptyHistoryHint)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row align-center nav_btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: {
                type: "button",
                "data-close": "",
                "aria-label": "Close reveal",
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.ok")))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }